const dataText = JSON.stringify([
    {
        group: '广州机房',
        y: 'L',
        unit: '℃',
        type: 'line',
        data: [
            { name: 'Mon', value: 160 },
            { name: 'Tue', value: 155 },
            { name: 'Wed', value: 150 },
            { name: 'Thu', value: 80 },
            { name: 'Fri', value: 70 },
            { name: 'Sat', value: 60 },
        ]
    }, {
        group: '深圳机房',
        type: 'bar',
        y: 'L',
        unit: 'MB',
        data: [
            { name: 'Mon', value: 200 },
            { name: 'Tue', value: 220 },
            { name: 'Wed', value: 170 },
            { name: 'Thu', value: 260 },
            { name: 'Fri', value: 270 },
            { name: 'Sat', value: 190 },
        ]
    }, {
        group: '关系3',
        type: 'line',
        unit: '人',
        y: 'R',
        data: [
            { name: 'Mon', value: 0.9 },
            { name: 'Tue', value: 0.8 },
            { name: 'Wed', value: 0.86 },
            { name: 'Thu', value: 0.88 },
            { name: 'Fri', value: 0.95 },
            { name: 'Sat', value: 0.96 },
        ]
    }
])

export default {
    attribute: {
        color: ['#3574d3', '#3574d3', '#3574d3'],
        title: {
            text: '',
            left: '20',
            top: 'top',
            textStyle: { fontSize: 18, color: '#ccc' }
        },
        legend: {
            show: false,
            orient: 'horizontal',
            x: 'center',
            y: 'bottom',
            textStyle: {
                color: '#ddd',
                fontSize: 12
            }
        },
        grid: {
            x: 10, y: 60, x2: 40, y2: 30, containLabel: true
        },
        xAxis: {
            show: true,
            type: 'category',
            name: '',
            axisLabel: {
                show: true,
                color: '#6aa9e4',
                fontSize: 12,
                rotate: 0
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#02438e'
                }
            },
            axisTick: {//x轴刻度线
                show: false,
                alignWithLabel: true
            },
            splitLine: {//网格线
                show: false,
                color: '#14477e',
            },
        },
        yAxis: [
            {
                show: false,
                type: 'value',
                position: 'left',
                alignTicks: false,
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#14477e'
                    }
                },
                splitLine: {
                    show: false, 
                     lineStyle: {
                        color: '#14477e'
                    }
                },
                axisTick: {//x轴刻度线
                    show: false,
                },
                axisLabel: {
                    formatter: '{value}℃',
                    color: '#6aa9e4',
                    fontSize: 13
                },
            }, {
                show: true,
                type: 'value',
                position: 'right',
                alignTicks: true,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#14477e'
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: ['#14477e', '#14477e']
                    }
                },
                axisLabel: {
                    formatter: '{value}%',
                    fontSize: 13
                },
            }
        ],
        series: {
            showBackground: false,
            borderRadius: 0,
            smooth: true,
            label: {
                show: false, //数值
                position: 'inside',
                color: '#6aa9e4',
                fontSize: 13,
                unit: true
            },
            barWidth: 20
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        dataZoom: {show: false,height:15},
        cptTableData:[
            { "name": "分组", "value": "", "namekey": "group" },
            { "name": "y轴", "value": "", "namekey": "y" },
            { "name": "类型", "value": "", "namekey": "type" },
            { "name": "单位", "value": "", "namekey": "unit" },
            { "name": "维度", "value": "", "namekey": "name" },
            { "name": "指标", "value": "", "namekey": "value" },
        ]
    },
    cptDataForm: { dataText: dataText, dataSource: 1, pollTime: 0 },
}
